import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { usePaginatedOffers } from "@/api/offerBank";
import { EditOfferFlow } from "@/features/CouponCodes/EditOfferFlow";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/coupon-codes/edit/$offerSlug",
)({
  component: EditOfferRoute,
});

function EditOfferRoute() {
  const { siteId, offerSlug } = Route.useParams();
  const navigate = useNavigate();

  const { data } = usePaginatedOffers(siteId, {
    states: ["active", "inactive"],
    page: 1,
    pageSize: 100,
  });

  const offer = data?.offers.find((o) => o.slug === offerSlug);

  const handleClose = () => {
    void navigate({
      to: "/settings/$siteId/coupon-codes",
      params: { siteId },
    });
  };

  if (!offer) {
    return null;
  }

  return <EditOfferFlow offer={offer} siteId={siteId} onClose={handleClose} />;
}
